import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path
      fill="#10A35D"
      d="m27.5 16-7 2-1 3h-5L11 18.5l-3.5-4L8 11l1.5-1.5L13 9l3 1.5 3 3 1.5-3 2.5-5 4-2L31 5l1.5 3-.5 3.5-4.5 4.5Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M8.333 36.667c0-3.07 2.61-5.556 5.834-5.556.262 0 .51.014.758.056.992-1.695 2.887-2.834 5.075-2.834s4.083 1.14 5.075 2.834c.248-.042.496-.056.758-.056 3.223 0 5.834 2.486 5.834 5.556M20 28.333V16.876c0-10.148 4.88-15.508 9.94-12.878 5.647 2.934 1.808 13.331-9.036 13.331M20 28.333v-7.888c0-8.938-4.88-13.659-9.94-11.342-5.647 2.584-1.808 11.741 9.036 11.741"
    />
  </svg>
);
export default SvgComponent;
